import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import AddVoucherModal from "../add-voucher-modal/AddVoucherModal";
import renderPrice from "../../utils/string/renderPrice";
import { clearVoucher } from "../../actions/voucher/voucherActions";
import styles from "./user-info.scss";

export class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { addVoucherModalVisible: false };
  }

  showAccountCreditModal() {
    this.setState({
      addVoucherModalVisible: true,
    });
  }

  close() {
    this.props.clearVoucher();
    this.setState({
      addVoucherModalVisible: false,
    });
  }

  render() {
    const { userInfo, isHome } = this.props;
    const name = userInfo ? userInfo.firstName : "";
    return (
      <div
        className={classNames(styles.userInfo, {
          [styles.isHome]: isHome,
          [styles.loaded]: !!userInfo,
        })}
      >
        <h2 className="sessioncamhidetext" data-testid="greeting">
          {name ? `Hello, ${name}` : "Hello"}
        </h2>
        <p className="mb-1" data-testid="account-credit">
          {`You have ${renderPrice((userInfo && userInfo.accountCredit) || "0")} credit`}
        </p>
        <div>
          <p className="mb-0">
            <button onClick={() => this.showAccountCreditModal()} className={styles["userInfo--link"]} data-testid="add-voucher-button">
              Add voucher
            </button>
          </p>
          {this.state.addVoucherModalVisible && <AddVoucherModal isOpen onClose={() => this.close()} data-testid="add-voucher-modal" />}
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    userInfo: state.user && state.user.userInfo,
  }),
  {
    clearVoucher,
  },
)(UserInfo);
